import format from "date-fns/format";
import { FetchMansionUnitsResponse } from "@/apis/property";
import Structure from "@/constants/Structure";

export type Connecting = {
  status: string;
  details: ConnectingDetail[];
};

export type ConnectingDetail = {
  type: string;
  direction: string;
  width?: string;
  contactWidth?: string;
  widthGroup?: string;
  contactWidthGroup?: string;
};

export type FormValues = {
  lastName: string;
  firstName: string;
  lastNameKana: string;
  firstNameKana: string;
  tel: string;
  contactTime: string;
  canContactTel: boolean | null;
  mailAddress: string;
  confirmMailAddress: string;
  canContactMail: boolean | null;
  postCode: string;
  pref: string;
  city: string;
  town: string;
  street: string;
  building: string;
  salePeriod: string;
  relation: string;
  propertyType: string;
  propertyPref: string;
  propertyCity: string;
  propertyTown: string;
  propertyStreet: string;
  roomNumber: string;
  line: string;
  station: string;
  walk: string;
  bus: string;
  propertyName: string;
  buildingName: string;
  floorPlan: string;
  story: string;
  undergroundStory: string;
  builtDateYear: string;
  builtDateMonth: string;
  unitSize: string;
  balconyDirection: string;
  houseSize: string;
  landSize: string;
  totalStory: string;
  structure: string;
  connecting: Connecting;
  isSame: boolean;
  saleReason: string;
  shopPrefId: string;
  shopId: string;
  referralSourceCd: string;
};

export type FormValidates = Omit<
  FormValues,
  | "connecting"
  | "propertyType"
  | "contactTime"
  | "canContactTel"
  | "canContactMail"
  | "salePeriod"
  | "relation"
  | "isSame"
> & {
  connecting?: string;
};

export type FormAddress = {
  prefId: number | null;
  cityId: number | null;
  townId: number | null;
};

export type Form = {
  values: FormValues;
  validates: FormValidates;
  addressIds: FormAddress;
  units: FetchMansionUnitsResponse[];
};

const initialFormState: Form = {
  values: {
    lastName: "",
    firstName: "",
    lastNameKana: "",
    firstNameKana: "",
    tel: "",
    contactTime: "指定なし",
    canContactTel: true,
    mailAddress: "",
    canContactMail: true,
    confirmMailAddress: "",
    postCode: "",
    pref: "",
    city: "",
    town: "",
    street: "",
    building: "",
    salePeriod: "",
    relation: "",
    propertyType: "mansion",
    propertyPref: "",
    propertyCity: "",
    propertyTown: "",
    propertyStreet: "",
    roomNumber: "",
    line: "",
    station: "",
    walk: "",
    bus: "",
    propertyName: "",
    buildingName: "",
    floorPlan: "",
    story: "",
    undergroundStory: "",
    builtDateYear: "2010",
    builtDateMonth: "10",
    unitSize: "",
    balconyDirection: "",
    houseSize: "",
    landSize: "",
    totalStory: "",
    structure: "",
    connecting: {
      status: "",
      details: [],
    },
    isSame: true,
    saleReason: "",
    shopPrefId: "",
    shopId: "",
    referralSourceCd: "",
  },
  validates: {
    lastName: "",
    firstName: "",
    lastNameKana: "",
    firstNameKana: "",
    tel: "",
    mailAddress: "",
    confirmMailAddress: "",
    postCode: "",
    pref: "",
    city: "",
    town: "",
    street: "",
    building: "",
    propertyPref: "",
    propertyCity: "",
    propertyTown: "",
    propertyStreet: "",
    roomNumber: "",
    line: "",
    station: "",
    walk: "",
    bus: "",
    propertyName: "",
    buildingName: "",
    floorPlan: "",
    story: "",
    undergroundStory: "",
    builtDateYear: "",
    builtDateMonth: "",
    unitSize: "",
    balconyDirection: "",
    houseSize: "",
    landSize: "",
    totalStory: "",
    structure: "",
    connecting: "",
    saleReason: "",
    shopPrefId: "",
    shopId: "",
    referralSourceCd: "",
  },
  addressIds: {
    prefId: null,
    cityId: null,
    townId: null,
  },
  units: [],
};

export default initialFormState;

export const defaultIfBlank = (value: string | number | null | undefined, defaultValue: string | number = "") => {
  return value === null || value === undefined || value === "" ? defaultValue : value;
};

export const ifResponseValueBlank = (value: any) => (value === undefined || value === null || value === 0 ? "" : value);

export const isTrue = (value: string | number | null | undefined) => {
  if (typeof value === "string") return value.toLowerCase() === "true";
  if (typeof value === "number") return value > 0;
  return !!value;
};

export const formatTenThousandPrice = (price: string | number | undefined, defaultValue: string | number = "-") => {
  return price ? Math.round(+price / 10000) : defaultValue;
};

export const localDateTimeFormatter: (date: number[], formatString: string, defaultValue?: string) => string = (
  date,
  formatString,
  defaultValue = ""
) => {
  let result = defaultValue;
  try {
    const tmpDate = new Date(...(date as [number, number, ...number[]]));
    result = format(tmpDate.setMonth(tmpDate.getMonth() - 1), formatString);
  } catch (error) {
    // 何もしない
  }
  return result;
};
